export { default } from './DefaultFrontPage';
